import { format } from "date-fns";
import { exportRowsToExcel } from "../../../../components/utils/printable-table-generator/exportRowsToExcel";

const formatDate = (value) => {
  if (!value) return "-";

  try {
    return format(new Date(value), "dd-MM-yyyy");
  } catch {
    return "-";
  }
};

export const copyToClipboard = ({ listData, filterValue, uiContext }) => {
  if (!listData || listData.length === 0) {
    uiContext.showErrorMsg("Error", "Tidak ada data yang dapat di-copy");
    return;
  }

  const formatNumber = (value) => `'${Number(value || 0).toLocaleString("id-ID")}`;

  let result = "";

  result += "\t\tLAPORAN PRODUCT CUSTOMER SUMMARY\n";
  result +=
    `Periode :\t${formatDate(filterValue?.start_date)}\tS/D\t${formatDate(filterValue?.end_date)}` +
    "\t\t" +
    `Tanggal Copy\t${formatDate(new Date())}\n`;
  result += "\n";

  result += ["NO", "PRODUCT", "TOTAL CUSTOMER BUY", "TOTAL QUANTITY", "REBUY %"].join("\t") + "\n";

  let totalCustomerBuy = 0;
  let totalQuantity = 0;

  listData.forEach((row, index) => {
    const customerBuy = Number(row?.total_customer_buy || 0);
    const quantity = Number(row?.total_quantity || 0);

    totalCustomerBuy += customerBuy;
    totalQuantity += quantity;

    result +=
      [
        index + 1,
        row?.product_name || "-",
        formatNumber(customerBuy),
        formatNumber(quantity),
        `${row?.rebuy_pct ?? 0}%`,
      ].join("\t") + "\n";
  });

  result +=
    ["", "TOTAL", formatNumber(totalCustomerBuy), formatNumber(totalQuantity), ""].join("\t") + "\n";

  navigator.clipboard
    .writeText(result)
    .then(() => {
      uiContext.showSuccessMsg("Success", "Data berhasil di-copy");
    })
    .catch(() => {
      uiContext.showErrorMsg("Error", "Gagal meng-copy data");
    });
};

export const exportToExcel = ({ listData, filterValue, uiContext }) => {
  if (!listData || listData.length === 0) {
    uiContext.showErrorMsg("Error", "Tidak ada data yang dapat di-export");
    return;
  }

  const rows = [];

  rows.push(["LAPORAN PRODUCT CUSTOMER SUMMARY"]);
  rows.push([
    "Periode :", formatDate(filterValue?.start_date), "S/D", formatDate(filterValue?.end_date),
    "", "Tanggal Copy", formatDate(new Date()),
  ]);
  rows.push([]);

  rows.push(["NO", "PRODUCT", "TOTAL CUSTOMER BUY", "TOTAL QUANTITY", "REBUY %"]);

  let totalCustomerBuy = 0;
  let totalQuantity = 0;

  listData.forEach((row, index) => {
    const customerBuy = Number(row?.total_customer_buy || 0);
    const quantity = Number(row?.total_quantity || 0);

    totalCustomerBuy += customerBuy;
    totalQuantity += quantity;

    rows.push([
      index + 1,
      row?.product_name || "-",
      customerBuy,
      quantity,
      `${row?.rebuy_pct ?? 0}%`,
    ]);
  });

  rows.push(["", "TOTAL", totalCustomerBuy, totalQuantity, ""]);

  exportRowsToExcel({
    rows,
    fileName: `Laporan_Product_Customer_Summary_${format(new Date(), "yyyyMMdd_HHmm")}.xlsx`,
  });
};
